import { type Dispatch, type SetStateAction, createContext, useContext } from 'react'

type ScrollContextType = {
  scrollTop: number
  isLockedScroll: boolean
  setScrollTop?: Dispatch<SetStateAction<number>>
  setIsLockedScroll: Dispatch<SetStateAction<boolean>>
}

const initialScrollContext: ScrollContextType = {
  scrollTop: 0,
  isLockedScroll: false,
  setScrollTop: () => {},
  setIsLockedScroll: () => {},
}

export const ScrollContext = createContext<ScrollContextType>(initialScrollContext)

export const useScrollContext = () => {
  return useContext(ScrollContext)
}
